export function generateName (type, title) {
  const hasKey = this.$te(type + '.' + title)
  const translatedTitle = this.$t(type + '.' + title) // $t :this method from vue-i18n, inject in @/lang/change.js
  if (hasKey) {
    return translatedTitle
  }
  return title
}

export function generateCode (code) {
  const hasKey = window.vm.$te('errorCode.' + code)
  // const hasKey = this.$te('errorCode.' + code)
  const translatedTitle = window.vm.$t('errorCode.' + code) // $t :this method from vue-i18n, inject in @/lang/change.js
  if (hasKey) {
    return translatedTitle
  }
  return code
}

export function generateButton (code) {
  const hasKey = window.vm.$te('route.' + code)
  // const hasKey = this.$te('errorCode.' + code)
  const translatedTitle = window.vm.$t('route.' + code) // $t :this method from vue-i18n, inject in @/lang/change.js
  if (hasKey) {
    return translatedTitle
  }
  return code
}



// WEBPACK FOOTER //
// ./src/utils/i18n/index.js